// extracted by mini-css-extract-plugin
module.exports = {"bar":"Bar__bar__dIye3"};